import React from "react";
import { URLImgFront } from '../../../../config/URLDB';

class Fechas extends React.Component {

    render() {
        return (
            <div className="px-3" data-aos="fade-right" data-aos-delay="1000">
                <div className="my-2 my-md-5">
                    <div className="d-flex justify-content-center flex-column align-items-center">
                        <img className="img-fluid" style={{ width: 'clamp(300px, 60vw, 500px)', aspectRatio: '500 / 177', display: 'block', touchAction: 'manipulation' }} src={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/TituloFechasImportantes.svg`} alt="Coopenautas" />
                        <img className="img-fluid" style={{ width: '1200px', height: 'auto', display: 'block', touchAction: 'manipulation' }} src={`${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/Fechas.svg`} alt="Coopenautas" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Fechas;